import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

import useGlobalState from '../GlobalStateContext';
import MainLayout from '../layouts/MainLayout';
import Auth from '../services/Auth';

import { PermissionList, RoleList } from './Permissions';

type ProtectedRouteProps = {
    pageName?: string;
    roles?: RoleList;
    permissions?: PermissionList;
    children: React.ReactNode;
} & RouteProps;

export default function ProtectedRoute({
    pageName,
    roles = [],
    permissions = [],
    children,
    ...rest
}: ProtectedRouteProps) {
    const { loggedAdmin } = useGlobalState();

    return (
        <Route
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
            render={({ location }) => {
                if (!Auth.isAuthenticated()) {
                    return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
                }

                if (roles.length || permissions.length) {
                    // access is checked only if roles or permissions are provided
                    if (!loggedAdmin.hasAccess(roles, permissions)) {
                        return <Redirect to={{ pathname: '/', state: { from: location } }} />;
                    }
                }

                return <MainLayout pageName={pageName}>{children}</MainLayout>;
            }}
        />
    );
}
